import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import { Indicator } from '@mantine/core';
import { createClient } from '@/utils/supabase/client';

dayjs.extend(utc);

interface AnnouncementIndicatorProps {
  profileAnnouncement: string | null;
}

export function AnnouncementIndicator({ profileAnnouncement }: AnnouncementIndicatorProps) {
  if (!profileAnnouncement) return null;

  const [hasNewAnnouncements, setHasNewAnnouncements] = useState(false);
  //   const pathname = usePathname();

  const fetchAnnouncements = async () => {
    const supabase = createClient();
    const { data, error } = await supabase
      .from('announcements')
      .select('updated_at')
      .order('updated_at', { ascending: false })
      .limit(1)
      .single();

    if (error) {
      console.error('Error fetching announcements:', error);
      return;
    }

    if (data) {
      //   console.log(pathname);
      const lastUpdatedAnnouncement = dayjs.utc(data.updated_at);
      const lastProfileAnnouncement = dayjs.utc(profileAnnouncement);
      setHasNewAnnouncements(
        dayjs(lastUpdatedAnnouncement).isAfter(lastProfileAnnouncement) ? true : false
      );
    }
  };

  useEffect(() => {
    fetchAnnouncements();
  }, [profileAnnouncement]);

  if (!hasNewAnnouncements) {
    return null;
  }

  return <Indicator color="green" size={10} mr="lg" />;
}

export default AnnouncementIndicator;
